export interface RequiredCapabilities {
  canStart: boolean;
  canvas2d: boolean;
  persistentStorage: boolean;
  webAudio: boolean;
  serviceWorker: boolean;
  pointerEvents: boolean;
}

type BrowserWindow = Window & {
  AudioContext?: unknown;
  webkitAudioContext?: unknown;
};

export function probeRequiredCapabilities(scope: Window): RequiredCapabilities {
  let canvas2d = false;
  try {
    const canvas = scope.document.createElement("canvas");
    canvas2d = Boolean(canvas.getContext("2d"));
  } catch {
    canvas2d = false;
  }

  let persistentStorage = false;
  try {
    persistentStorage = "localStorage" in scope && scope.localStorage != null;
  } catch {
    persistentStorage = false;
  }

  const browser = scope as BrowserWindow;
  const webAudio =
    typeof browser.AudioContext === "function" ||
    typeof browser.webkitAudioContext === "function";

  let serviceWorker = false;
  try {
    serviceWorker = "serviceWorker" in scope.navigator;
  } catch {
    serviceWorker = false;
  }

  let pointerEvents = false;
  try {
    pointerEvents = "PointerEvent" in scope;
  } catch {
    pointerEvents = false;
  }

  return {
    canStart: canvas2d,
    canvas2d,
    persistentStorage,
    webAudio,
    serviceWorker,
    pointerEvents,
  };
}
